import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Trash2, Clock, Package } from "lucide-react";
import { api, gbp } from "../lib/api";

export default function RecipesPage() {
  const [recipes, setRecipes] = useState(null);

  const load = useCallback(() => api.get("/recipes").then((r) => setRecipes(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const remove = async (e, id) => {
    e.preventDefault();
    await api.delete(`/recipes/${id}`);
    load();
  };

  if (!recipes) return <p className="text-ink/50 py-10">Loading…</p>;

  return (
    <div className="space-y-6 animate-rise" data-testid="recipes-page">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-ink/50">Recipe builder</p>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl tracking-tight mt-1">Recipes</h1>
        </div>
        <Link to="/recipes/new" data-testid="new-recipe-button"
          className="h-11 px-4 rounded-lg bg-tea hover:bg-tea-hover text-tea-text text-sm font-medium flex items-center gap-2 transition-colors duration-200">
          <Plus size={16} /> New recipe
        </Link>
      </div>

      {recipes.length === 0 ? (
        <div className="bg-surface border border-dashed border-sand rounded-lg p-10 text-center" data-testid="recipes-empty-state">
          <p className="text-ink/60 text-sm">No dishes yet. Build one from your confirmed ingredients. No manual price entry.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="recipes-list">
          {recipes.map((r) => (
            <Link key={r.id} to={`/recipes/${r.id}`} data-testid={`recipe-card-${r.id}`}
              className="group bg-white border border-black/5 rounded-lg p-5 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading font-semibold text-lg leading-tight">{r.name}</h3>
                <button onClick={(e) => remove(e, r.id)} data-testid={`recipe-delete-${r.id}`} className="p-1.5 rounded hover:bg-sand text-ink/30 hover:text-tea-text"><Trash2 size={15} /></button>
              </div>
              <div className="flex items-center gap-4 mt-2 text-xs text-ink/50">
                <span className="flex items-center gap-1"><Package size={13} /> {r.portion_count} portions</span>
                <span className="flex items-center gap-1"><Clock size={13} /> {r.labour_minutes} min</span>
              </div>
              <div className="mt-4 pt-4 border-t border-sand flex items-end justify-between">
                <span className="text-xs uppercase tracking-[0.2em] text-ink/40 font-medium">Cost / portion</span>
                <span className="font-mono-num text-2xl font-semibold text-tea-text" data-testid={`recipe-cost-${r.id}`}>{gbp(r.costing?.cost_per_portion)}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
